<mat-card class="mat-card-no-padding">
    <div class="widget-container col-xs-12">
        <span class="smp-widget-title">{{ 'settings_widget.title.settings' | translate }}</span>
        <div class="row no-gutters mt-3">
            <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3 col-xl-2 pr-4 mb-3"
                 *ngFor="let setting of settings">
                <button id="{{idPrefix}}btn.{{setting.id}}"
                        mat-stroked-button
                        class="setting-btn full-width mat-elevation-z1"
                        (click)="routeToSetting(setting.route)">{{ setting.trans | translate }}</button>
            </div>
        </div>
    </div>
</mat-card>
